import React from "react";
import "../css/visionMission.css"; // Make sure this CSS file exists

const VisionMission = () => {
  return (
    <section className="vision-mission-section">
      <div className="container">
        <h2 className="section-title">Our Vision & Mission</h2>
        <div className="content-box">
          {/* Mission Section */}
          <div className="mission-box">
            <h3>Our Mission</h3>
            <p>
              At <b>Auxilium Private Technical Training Centre</b>, we aim to
              bridge the gap between academic learning and industry
              requirements by imparting hands-on training, modern technical
              knowledge, and practical skills. Our mission is to nurture
              skilled professionals who can contribute effectively to the
              workforce and enhance the industrial growth of the nation.
            </p>
            <ul>
              <li>To deliver quality technical education and practical training.</li>
              <li>To develop skilled, confident, and responsible professionals.</li>
              <li>
                To foster an environment of learning, innovation, and personal
                growth.
              </li>
              <li>
                To bridge the gap between education and employment by aligning
                with industry standards.
              </li>
            </ul>
          </div>

          {/* Vision Section */}
          <div className="vision-box">
            <h3>Our Vision</h3>
            <p>
              To become a centre of excellence in vocational training,
              providing skill-based education that meets the demands of today’s
              industries and contributes to the development of society.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
